module.exports = __webpack_public_path__ + "vue-app/img/curve-prune-big.883de996.svg";